<template>
<div class="content-box">
    <div class="login-logo">
        <a href=""><img src='/img/logo-atualizado.png' style='height:140px;'></a>
    </div>   
    <p style='text-align:center'>Versão 1.00.00 - 20/02/2019</p>    
</div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
